import type { DisciplinePaymentProduct } from '../model/interfaces'
import type { ApiResponse } from '@shared/api'

import { getAxiosErrorMessage } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

import { useDisciplinePaymentLinksStore } from '../model/payment-links/store'

interface DisciplinePaymentProductsApiOptions {
  customerId: number
}

/** `GET /admin-api/products` — everything the customer's pricing model offers: ONE_TIME rows, then SUBSCRIPTION rows. */
export const useDisciplinePaymentProductsApi = async (
  options: DisciplinePaymentProductsApiOptions,
): Promise<DisciplinePaymentProduct[] | null> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()
  const store = useDisciplinePaymentLinksStore()

  const url = useAdminRoutes('admin.products', { customer_id: options.customerId })

  store.setLoading(true)

  try {
    if (!url) {
      toast.error('Unexpected error. Invalid request URL.')
      return null
    }

    const { data } = await $axios.get<ApiResponse>(url)
    const products: DisciplinePaymentProduct[] = data.data ?? []

    store.setProducts(products)

    return products
  } catch (err: unknown) {
    toast.error(getAxiosErrorMessage(err))
    return null
  } finally {
    store.setLoading(false)
  }
}
